<template>
    <div>
        <div>
    <b-card class="card-news-form" header-tag="header" footer-tag="footer">
      <!-- for loading page -->
      <app-loading :className="isLoading ? 'loading' : ''"></app-loading>

        <div slot="header">
          <i class="fa fa-list-ul" aria-hidden="true"></i>
            Announcement Form
          <div class="card-header-actions">
            <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
              <small class="text-muted">docs</small>
            </a>
          </div>
        </div>
        <div>

          <b-row>
            <b-col sm="12">
              <alert-success :redirectName="'jwt-home'" :show="successMessage != ''"> {{ successMessage }} </alert-success>
              <b-alert class="text-center" :show="errorMessage != ''" variant="danger"> {{ errorMessage }} </b-alert>

            <!-- Name -->
              <b-form-group>
                <label>Name</label>
                <b-input-group>
                    <b-input :state="feedback(fieldErrors.name)" v-model="form.name" placeholder="please enter topic"></b-input>
                </b-input-group>
              </b-form-group>

              <!-- Type -->
              <b-form-group>
              <label>Type</label>
              <v-select :class="classSelect(fieldErrors.key.type)"
                 v-model="form.key.type"
                 :options="['secret', 'key']"
                 :placeholder="'please select type of json web token'"
                 :disabled="typeof $route.params.id !== 'undefined'" >
              </v-select>
              </b-form-group>

                <!-- Secret Group -->
                <b-card
                    border-variant="secondary"
                    sub-title="Secret"
                    v-if="'secret' === form.key.type && typeof $route.params.id === 'undefined'"
                >
                    <b-form-group>
                        <b-input-group>
                            <b-input type="password" :state="feedback(fieldErrors.key.secret)" v-model="form.key.secret" placeholder="please enter secret"></b-input>
                        </b-input-group>
                    </b-form-group>
                </b-card>

                <!-- Key Group -->
                <b-card
                    border-variant="secondary"
                    sub-title="Key"
                    v-show="'key' === form.key.type && typeof $route.params.id === 'undefined'"
                >
                    <b-form-group>
                        <label>Public Key</label>
                        <b-input-group>
                            <b-form-textarea
                                v-model="form.key.publicKey"
                                placeholder="Enter public key"
                                rows="3"
                                max-rows="6"
                                :state="feedback(fieldErrors.key.publicKey)"
                            ></b-form-textarea>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group>
                        <label>Private Key</label>
                        <b-input-group>
                            <b-form-textarea
                                v-model="form.key.privateKey"
                                placeholder="Enter private key"
                                rows="3"
                                max-rows="6"
                                :state="feedback(fieldErrors.key.privateKey)"
                            ></b-form-textarea>
                        </b-input-group>
                    </b-form-group>
                </b-card>

            <b-card
                border-variant="secondary"
                sub-title="Options"
            >
              <!-- algorithm -->
              <b-form-group>
                <label>Algorithm</label>
                <b-input-group>
                    <v-select :class="classSelect(fieldErrors.options.algorithm)"
                        v-model="form.options.algorithm"
                        :options="algorithmList"
                        :placeholder="'please select algorithm'">
                    </v-select>
                </b-input-group>
              </b-form-group>

              <!-- expiresIn -->
              <b-form-group>
                <label>Expires In</label>
                <b-input-group>
                    <b-input :state="feedback(fieldErrors.options.expiresIn)" v-model="form.options.expiresIn" placeholder="please enter expire in 60, 2 days, etc"></b-input>
                </b-input-group>
              </b-form-group>

              <!-- audience -->
              <b-form-group>
                <label>Audience</label>
                <b-input-group>
                    <b-input :state="feedback(fieldErrors.options.audience)" v-model="form.options.audience" placeholder="please enter audience"></b-input>
                </b-input-group>
              </b-form-group>

              <!-- issuer -->
              <b-form-group>
                <label>Issuer</label>
                <b-input-group>
                    <b-input :state="feedback(fieldErrors.options.issuer)" v-model="form.options.issuer" placeholder="please enter issuer"></b-input>
                </b-input-group>
              </b-form-group>

              <!-- subject -->
              <b-form-group>
                <label>Subject</label>
                <b-input-group>
                    <b-input :state="feedback(fieldErrors.options.subject)" v-model="form.options.subject" placeholder="please enter subject"></b-input>
                </b-input-group>
              </b-form-group>
            </b-card>

            </b-col>
          </b-row>
        </div>
        <div slot="footer">
          <b-button @click="$router.go(-1)" class="mr-2" size="sm" variant="secondary">
            <i class="fa fa-angle-left" aria-hidden="true"></i>
            Back
          </b-button>
          <b-button :disabled="!isActive" @click="save" class="mr-2" type="submit" size="sm" variant="primary">
            <i class="fa fa-dot-circle-o"></i>
            Save
          </b-button>
          <b-button :disabled="!isActive" @click="save" class="mr-2" type="submit" size="sm" variant="outline-primary">
            <i class="fa fa-dot-circle-o"></i>
            Change secret or key
          </b-button>
          <b-button :disabled="!isActive" v-b-modal.confirmDelete v-if="$route.params.id" type="reset" size="sm" variant="danger">
            <i class="fa fa-ban"></i>
            Delete
          </b-button>
          <alert-confirm
            :id="'confirmDelete'"
            @confirm="deleteJwt">
            confirm to delete ?
          </alert-confirm>
        </div>
    </b-card>
    </div>
    </div>
</template>

<script>
import AlertSuccess from '../../components/alert/AlertSuccess';
import AlertConfirm from '../../components/alert/AlertConfirm';
import Loading from '../../components/Loading';
import vSelect from 'vue-select';

export default {
  data () {
    return {
      successMessage: '',
      errorMessage: '',
      thumbnail: {},
      isLoading: false,
      isActive: true,
      fieldErrors: {
        name: '',
        key: {},
        options: {}
      },
      form: {
        name: '',
        key: {
          type: '',
          secret: '',
          publicKey: '',
          privateKey: ''
        },
        options: {
          algorithm: 'HS256',
          expiresIn: '',
          audience: '',
          issuer: '',
          subject: ''
        }
      },
      algorithmList: ['HS256', 'HS384', 'HS512', 'RS256', 'RS384', 'RS512', 'PS256', 'PS384', 'PS512', 'ES256', 'ES384', 'ES512']
    };
  },
  methods: {
    getData () {
      const id = this.$route.params.id;
      if (id) {
        this.isLoading = true;
        this.axios.get(process.env.VUE_APP_ACCESS_CONTROL_URL + '/jwt?id=' + id)
          .then(response => {
            const data = response.data.data;
            const jwt = data[0];
            if (!jwt) {
              throw new Error('data not found');
            }
            this.form = {
              name: jwt.name,
              key: {
                type: jwt.type,
                secret: '',
                publicKey: '',
                privateKey: ''
              },
              options: {
                algorithm: jwt.options.algorithm,
                expiresIn: jwt.options.expiresIn,
                audience: jwt.options.audience,
                issuer: jwt.options.issuer,
                subject: jwt.options.subject
              }
            };
          })
          .catch(error => {
            this.handleError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.setDefault();
      }
    },
    changeThumbnailFile (e) {
      const files = e.target.files || e.dataTransfer.files;
      this.thumbnail = files[0];
      this.previewThumbnail = URL.createObjectURL(this.thumbnail);
    },
    handleError (error) {
      this.fieldErrors = {
        name: '',
        key: {},
        options: {}
      };
      this.errorMessage = error.message;
      if (error.response) {
        this.errorMessage = error.response.data.message + ' : ' + error.response.data.data[0].msg;
        const data = error.response.data.data;
        this.setFieldErrors(data);
      }
      this.isLoading = false;
      this.isActive = true;
    },
    setFieldErrors (fields) {
      if (fields) {
        for (const field of fields) {
          this.fieldErrors[field.param] = { message: field.msg, isCorrect: false };
        }
      }
    },
    deleteJwt () {
      this.isActive = false;
      this.isLoading = true;
      this.axios.delete(process.env.VUE_APP_ACCESS_CONTROL_URL + '/jwt/' + this.$route.params.id)
        .then(response => {
          this.successMessage = 'delete reward success';
        })
        .catch(error => {
          this.handleError(error);
        });
    },
    save () {
      this.isActive = false;
      this.fieldErrors = {
        name: '',
        key: {},
        options: {}
      };
      this.isLoading = true;
      const id = this.$route.params.id;

      if (id) { // update
        const json = { // do not anything about secret key when update.
          name: this.form.name,
          key: {},
          options: this.form.options
        };
        this.axios.patch(process.env.VUE_APP_ACCESS_CONTROL_URL + '/jwt/' + id, json)
          .then(response => {
            this.successMessage = 'update jwt finish';
          })
          .catch(error => {
            this.handleError(error);
          });
      } else { // create
        this.axios.post(process.env.VUE_APP_ACCESS_CONTROL_URL + '/jwt/signature', this.form)
          .then(response => {
            this.successMessage = 'create jwt finish';
          })
          .catch(error => {
            this.handleError(error);
          });
      }
    },
    setDefault () {
      this.form = {
        name: '',
        key: {
          type: '',
          secret: '',
          publicKey: '',
          privateKey: ''
        },
        options: {
          algorithm: 'HS256',
          expiresIn: '',
          audience: '',
          issuer: '',
          subject: ''
        }
      };
    }
  },
  computed: {
    feedback () {
      return data => {
        if (!data) {
          return null;
        } else {
          return data.isCorrect;
        }
      };
    },
    classSelect () {
      return data => {
        if (!data) {
          return '';
        } else {
          return 'select-validate-fail';
        }
      };
    }
  },
  components: {
    AlertSuccess,
    AlertConfirm,
    'app-loading': Loading,
    'v-select': vSelect
  },
  mounted () {
    this.getData();
  },
  watch: {
    '$route' (to, from) {
      this.getData();
    }
  }
};
</script>

<style scoped>
    .list-item {
    display: inline-block;
    margin-right: 10px;
    }
    .list-enter-active, .list-leave-active {
    transition: all 0.5s;
    }
    .list-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateX(30px);
    }
    .list-enter {
    opacity: 0;
    transform: translateY(30px);
    }
    .thumbnail{
      width: auto;
      max-height: 150px;
      -webkit-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      -moz-box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.75);
      margin-bottom: 5px;
    }
    .fix-font{
        margin-top: 8px;
        margin-left: 10px;
        margin-right: 10px;
    }
    .select-condition {
        width: 120px;
    }
    .hint{
      font-size: 9px;
      color: #f86c6b;
    }
</style>

<style>
   .select-condition .vs__dropdown-toggle {
        padding: 0 0 7px;
    }
  .select-validate-fail .vs__search::placeholder,
  .select-validate-fail .vs__dropdown-toggle,
  .select-validate-fail .vs__dropdown-menu {
    border: 1px solid #f86c6b;
  }
  .ck-content { min-height:100px; }
  .ck.ck-button {
      color: #5c6873;
  }
  .v-select{
      width: 100%;
  }
</style>
